import { QueryClient } from '@tanstack/react-query';

/** Default retry rule: up to three retries, for network failures only. */
export const retryNetworkErrors = (failureCount: number, error: unknown) => {
  if (failureCount < 3) {
    const errorMessage = error instanceof Error ? error.message : '';

    const isNetworkError =
      !navigator.onLine ||
      errorMessage.includes('Network Error') ||
      errorMessage.includes('fetch');
    return isNetworkError;
  }

  return false;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: retryNetworkErrors,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});
